import { Component, Input, OnInit } from '@angular/core';
import { LoaderType } from '@nibras/shared/components';

@Component({
  selector: 'nibras-loader',
  templateUrl: './nibras-loader.component.html',
  styleUrls: ['./nibras-loader.component.scss']
})
export class NibrasLoaderComponent implements OnInit {
  @Input() type: LoaderType = LoaderType.content;
  @Input() lines = 1;
  @Input() lineHeight = 10; // value in pixels
  @Input() lineWidth: number | number[] = 12; // Expecting even numbers upto 12
  @Input() cssClass: string;
  @Input() color = 'primary';
  @Input() size = 30;
  @Input() lineGutter = 10;
  @Input() text: string;

  loaderType: typeof LoaderType = LoaderType;
  totalLines: Array<number>;
  lineClasses = '';

  ngOnInit() {
    this.lines = +this.lines;
    this.lineHeight = +this.lineHeight;

    this.totalLines = Array.isArray(this.lineWidth)
      ? this.lineWidth
      : Array(this.lines).fill(+this.lineWidth);

    this.lineGutter = +this.lineGutter;
  }

  ngOnChanges() {
    if (this.type === LoaderType.spinner && this.size === 30) {
      this.size = 150;
    }
  }
}
